import defineComponent from 'flight';

function bindAppEvents() {
    this.after('initialize', function() {
        let localNotificationEvents = [
            'data:item:item-bid-action',
            'data:item:wish-list-item-added',
            'data:item:wish-list-item-removed',
            'data:bid:below-reserve-price',
            'data:bid:higher-bidder-exists',
            'data:bid:leading-bidder'
        ];

        for (let i = 0; i < localNotificationEvents.length; i++) {
            this.on(document, localNotificationEvents[i], function() {
                document.location.href = 'trd://schedule-local-notifications';
            });
        }

        this.on(document, 'ui:site-header:search-visiblity-changed', function(
            evt,
            payload
        ) {
            if (!payload.visible && document.activeElement) {
                document.activeElement.blur();
            }
        });
    });
}

export default defineComponent.component(bindAppEvents);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/hybrid-app-events.js